<app-base-notification [base]="base" *ngIf="isVisible">
  <div [innerHTML]="translationText | translate: {
     'title': ('<a class=\'link-base\' href=\'' + collectionUrl + '\'>' + (params.item.title) + '</a>')}">
  </div>
</app-base-notification>
